import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutorisationSpecifique } from '../models/AutorisationSpecifique';
import { Step8 } from '../../../../shared/models/component-messages/mapaIN/step8';
@Component({
  selector: 'app-autorisation-specifique',
  templateUrl: './autorisation-specifique.component.html'
})
export class AutorisationSpecifiqueComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'AutorisationSpecifique';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() autorisationSpecifique: AutorisationSpecifique;

  public step8 = new Step8();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

